var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{directives:[{name:"b-modal",rawName:"v-b-modal.privacy-policy-modal",modifiers:{"privacy-policy-modal":true}}]},[_vm._v("\n  Privacy Policy\n")])}
var staticRenderFns = []

export { render, staticRenderFns }